import axios from "axios";

// a little queue to hold requests while we refresh
let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}
function onRefreshed(token) {
  subscribers.forEach((cb) => cb(token));
  subscribers = [];
}

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API || "http://localhost:5000/api",
  withCredentials: true,
});

// attach the access token to each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// on 401, try to refresh and retry
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { config, response } = err;

    // 1) if this is our refresh endpoint, don’t try to refresh again
    if (config.url?.endsWith("/auth/refresh")) {
      return Promise.reject(err);
    }

    if (
      response?.status === 401 &&
      response.data?.code === "TOKEN_EXPIRED" &&
      !config._retry
    ) {
      config._retry = true;
      if (isRefreshing) {
        // queue up the request until refresh is done
        return new Promise((resolve) => {
          subscribeTokenRefresh((token) => {
            config.headers.Authorization = `Bearer ${token}`;
            resolve(api(config));
          });
        });
      }

      isRefreshing = true;

      return new Promise((resolve, reject) => {
        api
          .post("/auth/refresh")
          .then(({ data }) => {
            localStorage.setItem("accessToken", data.accessToken);
            api.defaults.headers.Authorization = `Bearer ${data.accessToken}`;
            onRefreshed(data.accessToken);
            resolve(api(config));
          })
          .catch((e) => {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("authUser");
            reject(e);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(err);
  }
);

export default api;
